import { render, staticRenderFns } from "./imFaq.vue?vue&type=template&id=29751e56&"
import script from "./imFaq.vue?vue&type=script&lang=js&"
export * from "./imFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports